// extracted by mini-css-extract-plugin
module.exports = {"counter__button":"counter__button-1RC31","counter__buttonDisabled":"counter__buttonDisabled-3JPIg","counter__value":"counter__value-2X8lR"};